<template>
    <div class="text-slide">
        <div class="text-slide__photo" v-show="built" :style="style"></div>

        <transition name="slide-down">
            <div class="text-slide__icon" v-show="built">
                <img v-if="data.icon" :src="data.icon">
            </div>
        </transition>

        <transition name="slide-up">
            <div class="text-slide__text" v-show="built">
                <b>{{ data.title }}</b><br>
                <span>{{ data.text }}</span>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            data: Object
        },

        data: function() {
            return {
                built: false
            };
        },

        methods: {
            buildIn: function() {
                this.$set(this, "built", true);
            },

            buildOut: function() {
                this.$set(this, "built", false);
            }
        },

        computed: {
            style: function() {
                return this.data.photo
                    ? "background-image: url(" + this.data.photo + ")"
                    : "";
            }
        }
    };
</script>

<style scoped lang="scss">
    .text-slide__photo {
        position: absolute;

        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        background-size: cover;
        background-position: 50% 50%;

        z-index: 10;

        &::after {
            content: "";

            position: absolute;

            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            width: 100%;
            height: 100%;

            background-color: #000000;
            opacity: .33;
        }
    }

    .text-slide__icon
    {
        position: absolute;

        top: 200px;
        left: 200px;
        right: 200px;
        bottom: 200px;

        background-size: contain;
        background-position: 50% 50%;

        opacity: 0.33;

        z-index: 15;

        img
        {
            width: 100%;
            height: 100%;
        }
    }

    .text-slide__text {
        position: absolute;

        bottom: 0;
        left: 0;
        right: 0;

        padding: 200px 100px 100px 100px;
        font-size: 50px;

        z-index: 30;

        background: linear-gradient(
            to bottom,
            #00000000 0%,
            #00000066 33%,
            #00000099 100%
        );

        span {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

    .slide-down-enter-active {
        transition: all 1s ease;
    }
    .slide-down-leave-active {
        transition: all 1s ease;
    }
    .slide-down-enter,
    .slide-down-leave-to {
        transform: translateY(-200px);
        opacity: 0;
    }

    .slide-up-enter-active {
        transition: all 1s ease;
    }
    .slide-up-leave-active {
        transition: all 1s ease;
    }
    .slide-up-enter,
    .slide-up-leave-to {
        transform: translateY(200px);
        opacity: 0;
    }
</style>